<template>
    <div class="columns delivery" :class="suspendedClassObject">
        <div class="column is-paddingless">
            <div class="columns is-mobile is-multiline delivery__main">
                <div class="column is-9 delivery__header-column">
                    <p class="is-size-5 is-marginless delivery__title">
                        <b><span class="delivery__green">{{ delivery.client_details.name }}</span>, {{ delivery.client_details.adress }}, {{ delivery.client_details.adress2 }}</b>
                    </p>
                </div>
                <div class="column delivery__header-column">
                    <p class="is-size-7 has-text-right">
                        {{ delivery.client_details.city }}
                    </p>
                    <p class="is-size-7 has-text-right has-text-danger">
                        {{ delivery.acronym }}
                    </p>
                </div>
                <div class="column is-7">
                     <p class="delivery__text">
                        {{ delivery.business_cards.access_code }}
                    </p>
                    <p class="delivery__text">
                        <svg-icon type="clock" class="delivery__icon"
                            :class="{ 'delivery__icon--danger': delivery.delivery_time_highlighted === 'danger', 'delivery__icon--flashy-orange': delivery.delivery_time_highlighted === 'flashy-orange' }" />
                        <span :class="{ 'has-text-danger': delivery.delivery_time_highlighted === 'danger', 'has-text-flashy-orange': delivery.delivery_time_highlighted === 'flashy-orange' }">
                            {{ time }}
                        </span>
                    </p>
                    <p class="delivery__text">
                        <a :href="`tel:${delivery.business_cards.phone}`">
                            <svg-icon type="phone" class="delivery__icon" />
                            <span class="delivery__underline">
                                {{ delivery.business_cards.first_name }} {{ delivery.business_cards.last_name }}
                            </span>
                        </a>
                    </p>
                    <p class="delivery__text" v-if="delivery.bok">
                        <a :href="`tel:${delivery.bok.phone}`">
                            <svg-icon type="bok" class="delivery__icon" />
                            <span class="delivery__underline">
                                BOK: {{ delivery.bok.name }} {{ delivery.bok.surname }}
                            </span>
                        </a>
                    </p>

                </div>
                <div class="column is-5">
                    <div class="columns is-mobile is-marginless">
                        <div class="column is-6 is-paddingless">
                            <p class="delivery__text">
                                <svg-icon type="weight" class="delivery__icon" />
                                {{ delivery.weight }}kg
                            </p>
                            <p class="delivery__text" v-if="distance">
                                <a v-if="isIpone"
                                    :href="`http://maps.apple.com/?q=${delivery.client_details.latitude},${delivery.client_details.longitude}`">
                                    <svg-icon type="map" class="delivery__icon" />
                                    <span class="delivery__underline">
                                        {{ distance }}
                                    </span>
                                </a>
                                <a v-if="!isIpone"
                                    :href="`google.navigation:q=${delivery.client_details.latitude},${delivery.client_details.longitude}`">
                                    <svg-icon type="map" class="delivery__icon" />
                                    <span class="delivery__underline">
                                        {{ distance }}
                                    </span>
                                </a>
                            </p>
                            <p class="delivery__text" v-if="!delivery.is_planning && !isArchive">
                                <svg-icon type="return" class="delivery__icon" />
                                {{ delivery.return_packages }}
                            </p>
                        </div>
                        <div v-if="!delivery.is_planning || isArchive" class="column is-6 is-paddingless is-spaceEvenly is-fullheight">
                            <template v-if="!isArchive">
                                <button class="button button--is-flat" v-if="!delivery.delivered"
                                    @click="confirmDelivery(delivery.id)">
                                    <svg-icon type="box" />
                                </button>
                                <button v-else class="button button--is-flat" @click="rollbackDelivery(delivery.id)">
                                    <svg-icon type="box" />
                                </button>
                            </template>
                            <button class="button button--is-flat" @click="addNote(delivery.id)">
                                <svg-icon type="alert"
                                    :class="{ 'svg-icon--active': delivery.delivery_notes.length > 0 }" />
                            </button>
                        </div>
                    </div>
                </div>
                <div class="column is-12">
                    <div class="delivery__comments"
                        :class="{ 'delivery__comments--active': activeComment === delivery.id }"
                        v-if="delivery.complaints.description" @click="toggleComments(delivery)">
                        <svg-icon type="alert" class="delivery__icon" />
                        <p class="delivery__text" v-for="(item, index) in complaintList" :key="index">
                            {{ item }}
                        </p>
                    </div>
                </div>

                <div class="column is-12 is-vcentered delivery__arrow" @click="toggle">
                    <hr class="delivery__hr" />
                    <button class="button button--is-flat">
                        <svg-icon type="arrow" class="svg-icon--large delivery__button"
                            :class="{ 'svg-icon--rotate': active }" />
                    </button>
                    <hr class="delivery__hr" />
                </div>
            </div>
            <div class="columns delivery__slide-wrapper">
                <transition name="slide-down">
                    <div class="column is-12" v-if="active">
                        <div class="columns is-mobile delivery__content">
                            <div class="column">
                                <div class="content" v-if="delivery.code || delivery.ean">
                                    <p class="delivery__code-detail">
                                        <strong>Kod dostępu:</strong> {{ delivery.code || delivery.ean }}
                                    </p>
                                </div>
                                <div class="content">
                                    <p class="delivery__description">
                                        {{ delivery.order_details.delivery_remarks }}
                                    </p>
                                </div>
                                <div class="columns is-mobile is-marginless"
                                    v-for="(delivery_package, package_index) in delivery.delivery_packages"
                                    v-bind:key="package_index">
                                    <div class="column is-3 delivery__image">
                                        <img :src="boxImage(delivery_package.image_url)" alt="Box" />
                                    </div>
                                    <div class="column is-5">
                                        <p>
                                            {{ delivery_package.package_name }} <span class="delivery__weight">({{
                                                    delivery_package.weight_limit
                                            }}kg)</span>
                                            <br /><span class="delivery__amount">x{{ delivery_package.amount }}</span>
                                        </p>
                                    </div>
                                    <div class="column is-4">
                                        <ul class="delivery__products">
                                            <li v-for="(product, product_index) in delivery_package.delivery_products"
                                                v-bind:key="product_index" class="delivery__product_item">
                                                {{ product.product_name }} {{ product.product_amount }}{{
                                                        product.measure_unit
                                                }}
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon'
import { calcDistance } from '@/helpers/calc-distance'
import localforage from 'localforage'

export default {
    name: 'delivery',
    components: {
        'svg-icon': SvgIcon
    },
    data() {
        return {
            id: null,
            active: false,
            now: null,
            publicPath: process.env.BASE_URL,
            activeComment: 0,
            complaintList: []
        }
    },
    props: {
        delivery: {
            require: true,
            type: Object

        },
        isArchive: {
            require: false,
            default: false,
            type: Boolean
        }
    },
    watch: {
        currentDelivery() {
            if (this.currentDelivery == this._uid) {
                this.active = true
            } else {
                this.active = false
            }
        }
    },
    computed: {
        isIpone() {
            return /(iPhone|iPad|iPod)/.test(navigator.userAgent)
        },
        time() {
            return this.delivery.delivery_time_from == null || this.delivery.delivery_time_to === null ?
                'Bez ograniczeń' :
                `${this.delivery.delivery_time_from} - ${this.delivery.delivery_time_to}`
        },
        distanceMeters() {
            if (this.$store.getters.getGeolocation !== null) {
                let lat1 = this.$store.getters.getGeolocation.latitude
                let lng1 = this.$store.getters.getGeolocation.longitude
                let lat2 = this.delivery.client_details.latitude
                let lng2 = this.delivery.client_details.longitude

                return calcDistance(lat1, lng1, lat2, lng2, 'm').toFixed(0)
            } else return null
        },
        distance() {
            if (this.$store.getters.getGeolocation !== null) {

                let distanceKm = (this.distanceMeters / 1000) * 1.25
                let distanceM = this.distanceMeters * 1.25
                distanceKm = (distanceKm >= 100) ? distanceKm.toFixed(0) : distanceKm.toFixed(1)

                return (distanceM >= 1000) ? `${distanceKm}km` : `${distanceM}m`
            } else return null
        },
        currentDelivery() {
            return this.$store.getters.getCurrentDelivery
        },
        deliveryCancellationReasons() {
            return this.$store.getters.getDeliveryCancellationReasons
        },
        suspendedClassObject() {
            let c = { 'suspended-item': this.delivery.to_verification }

            c[`delivery-${this.id}`] = true

            return c;
        }
    },
    methods: {
        toggleComments(delivery) {
            if (this.activeComment === delivery.id) {
                this.activeComment = 0
            } else {
                this.activeComment = delivery.id
            }
        },
        getCompleint(message) {
            // message could be null
            if (!message) {
                return false
            }
            if (Object.keys(message).length > 0) {
                Object.keys(message).forEach(index => {
                    if (message[index].d !== null) {
                        const item = `${message[index].d}: ${message[index].m}`;
                        this.complaintList.push(item)
                    }
                });
            }
        },
        toggle() {
            if (this.active) {
                // if active then hide by sending null to store
                this.$store.dispatch('setCurrentDelivery', null)
                this.$store.dispatch('setScrollingStatus', false)
                this.$store.dispatch('hideNavbar', true)
            } else {
                // if hidden then open by sending current id to store
                // watcher currentDelivery will compare id and set active to true
                this.$store.dispatch('setCurrentDelivery', this._uid)
                this.$store.dispatch('setScrollingStatus', true)
                this.$store.dispatch('hideNavbar', true)
                setTimeout(() => {
                    this.$scrollTo(`.delivery-${this.id}`, 500, {
                        onDone: () => {
                            this.$store.dispatch('setScrollingStatus', false)
                        }
                    })
                }, 100)
            }
        },
        boxImage(image_url) {
            return (image_url == '' || image_url === 'undefined') ? `${this.publicPath}img/box.png` : image_url
        },
        rollbackDelivery(deliveryId) {
            // just for testing purposes
            let content = `<p><b>Anuluje dostarczenie dostawy na adres:</b><p><p>`;
            content += this.delivery.client_details.name ? `<b>${this.delivery.client_details.name}</b><br />` : ''
            content += this.delivery.client_details.adress ? `${this.delivery.client_details.adress}<br />` : ''
            content += this.delivery.client_details.adress2 ? `${this.delivery.client_details.adress2}<br />` : ''
            content += this.delivery.client_details.city ? `${this.delivery.client_details.city}<br />` : ''
            content += this.delivery.client_details.postcode ? `${this.delivery.client_details.postcode}<br />` : ''
            content += `</p>`
            this.$store.dispatch('showModal', {
                action: {
                    confirm: {
                        name: 'rollbackDelivery',
                        payload: {
                            id: deliveryId,
                            delivered: false
                        }
                    },
                    discard: {
                        name: 'hideModal'

                    }
                },
                button: {
                    confirm: 'Nie dostarczono',
                    discard: 'Anuluj'
                },
                content: {
                    title: 'Anulowanie dostarczenia dostawy',
                    content: content
                }
            })
            //            this.$store.dispatch('rollbackDelivery', { id: deliveryId })
        },
        addNote(deliveryId) {
            let content = `<p><b>Dodaj uwagę do dostawy na adres:</b><p><p>`;
            content += this.delivery.client_details.name ? `<b>${this.delivery.client_details.name}</b><br />` : ''
            content += this.delivery.client_details.adress ? `${this.delivery.client_details.adress}<br />` : ''
            content += this.delivery.client_details.adress2 ? `${this.delivery.client_details.adress2}<br />` : ''
            content += this.delivery.client_details.city ? `${this.delivery.client_details.city}<br />` : ''
            content += this.delivery.client_details.postcode ? `${this.delivery.client_details.postcode}<br />` : ''
            content += `</p>`
            this.$store.dispatch('showModal', {
                action: {
                    confirm: {
                        name: 'addNote',
                        payload: {
                            id: deliveryId,
                        }
                    },
                    discard: {
                        name: 'hideModal'

                    }
                },
                button: {
                    confirm: 'Wyślij',
                    discard: 'Anuluj'
                },
                content: {
                    title: 'Dodaj uwagę',
                    content: content,
                    textarea: true
                }
            })
        },
        confirmDelivery(deliveryId) {
            this.$store.dispatch('checkTokenValidity').then(() => {
                localforage.getItem('checkDistance').then(checkDistance => {
                    if (this.distanceMeters < 500 || checkDistance == 0) {
                        let content = `<p><b>Potwierdzam dostawę na adres:</b><p><p>`;
                        content += this.delivery.client_details.name ? `<b>${this.delivery.client_details.name}</b><br />` : ''
                        content += this.delivery.client_details.adress ? `${this.delivery.client_details.adress}<br />` : ''
                        content += this.delivery.client_details.adress2 ? `${this.delivery.client_details.adress2}<br />` : ''
                        content += this.delivery.client_details.city ? `${this.delivery.client_details.city}<br />` : ''
                        content += this.delivery.client_details.postcode ? `${this.delivery.client_details.postcode}<br />` : ''
                        content += `</p>`
                        this.$store.dispatch('fetchDeliveryCancellationReasons').then(() => {
                            this.$store.dispatch('showModal', {
                                action: {
                                    confirm: {
                                        name: 'confirmDelivery',
                                        payload: {
                                            id: deliveryId,
                                            delivered: true
                                        }
                                    },
                                    discard: {
                                        name: 'showModal',
                                        payload: {
                                            action: {
                                                confirm: {
                                                    name: 'confirmDelivery',
                                                    payloadFromSelect: true,
                                                    payload: {
                                                        id: deliveryId
                                                    }
                                                },
                                                discard: { name: 'hideModal' }
                                            },
                                            button: {
                                                confirm: 'Potwierdź',
                                                discard: 'Anuluj'
                                            },
                                            content: {
                                                title: 'Powód niedostarczenia',
                                                content: 'Podaj powód niedostarczenia:',
                                                select: this.deliveryCancellationReasons
                                            }
                                        }
                                    }
                                },
                                button: {
                                    confirm: 'Dostarczono',
                                    discard: (this.delivery.to_verification ? false : 'Nie dostarczono')
                                },
                                content: {
                                    title: 'Potwierdzenie dostawy',
                                    content: content
                                }
                            })
                        })
                    } else {
                        this.$store.dispatch('fetchDeliveryCancellationReasons').then(() => {
                            this.$store.dispatch('showModal', {
                                action: {
                                    confirm: {
                                        name: 'hideModal'
                                    }
                                },
                                button: {
                                    confirm: 'OK'
                                },
                                content: {
                                    title: 'Uwaga !',
                                    content: 'Musisz znajdować się w strefie adresu dostawy aby raportować status'
                                }
                            })
                        })
                    }
                });
            }).catch(error => {
                this.$router.push({ name: 'logout' })
                this.$store.dispatch('addNotification', {
                    type: 'warning',
                    content: error
                })
            })
        }
    },
    created() {
        this.id = this._uid
        setInterval(() => {
            this.now = new Date()
        }, 1000)
    },
    mounted() {
        this.getCompleint(this.delivery.complaints.description)
    }
}
</script>

<style lang="sass">
    @import "@/styles/variables"

    .suspended-item
        opacity: 0.5
        filter: grayscale(1)

    .has-text-flashy-orange
        color: #ff6f00

    .delivery
        $this: &

        &__icon
            margin-right: 0.25rem
            min-width: 1.2rem
            display: inline-block
            &--danger
                path
                    fill: $danger
                    stroke: $danger
            &--flashy-orange
                path
                    fill: $flashy-orange
                    stroke: $flashy-orange
        &__description
            font-weight: 300
            text-transform: uppercase

        &__code
            margin-top: 2px

        &__code-detail
            font-size: 0.9rem
            margin-bottom: 0.5rem
            padding: 0.3rem 0.5rem
            background: rgba($green, 0.08)
            border-radius: 4px
            display: inline-block

        &__complaints
            font-weight: 300
            color: $red

        &__title
            text-transform: uppercase

        &__green
            color: $green

        &__main
            background-color: $grey-light

        &__arrow
            padding-top: 0 !important
            display: flex

        &__button
            padding-left: 1rem
            padding-right: 1rem

        &__header-column
            padding-bottom: 0 !important

        &__info
            text-transform: uppercase
            font-weight: 300

        &__hr
            background-color: $grey
            height: 1px
            width: 100%
            margin: 0

        &__slide-wrapper
            overflow: hidden
            background-color: #fff

        &__text
            font-weight: 500
            margin-bottom: 0.75rem

        &__underline
            padding-bottom: 0.15rem
            border-bottom: 0.5px solid $green

        &__content
            padding-bottom: 1.25rem
            background-color: #fff

        &__comments
            height: 100px
            transition: 0.3s ease-in-out
            overflow: hidden
            &--active
                height: 100%
                transition: 0.3s ease-in-out
        &__commentsText
            height: 100%
            font-weight: 300
        &__image
            padding-top: 0 !important

            img
                width: 100%

        &__weight
            font-weight: 300

        &__amount
            font-weight: 600
            font-size: $size-5

        &__products
            list-style: none

        &__product_item
            display: inline

            &:not(:last-child)
                &::after
                    content: ","
</style>
